import { data, redirect } from "react-router";
import { Logo } from "~/components/general/Logo";
import { Button } from "~/components/ui/button";
import type { Route } from "./+types/index";

export async function loader({ request, context }: Route.LoaderArgs) {
	const { getServerSession } = await import("@server/auth/auth");
	const authSession = await getServerSession(request);

	if (authSession?.user) {
		// Redirect based on role
		const dbUser = await context.db.query.user.findFirst({
			where: (u, { eq }) => eq(u.id, authSession.user.id),
		});
		const roles = Array.isArray(dbUser?.roles) ? dbUser.roles : [];
		if (dbUser?.role === "admin") {
			return redirect("/admin");
		}
		if (roles.includes("servicer_staff")) {
			return redirect("/servicer");
		}
		if (roles.includes("originator_staff")) {
			return redirect("/originator");
		}
		if (roles.includes("investor")) {
			return redirect("/investor");
		}
		return redirect("/borrower");
	}

	const environment = context.cloudflare.env.ENVIRONMENT;
	const isDevelopment = environment === "development";

	return data({ isDevelopment });
}

const Index = ({ loaderData }: Route.ComponentProps) => {
	const { isDevelopment } = loaderData;

	return (
		<div className="flex min-h-screen flex-col bg-gradient-to-br from-primary/5 via-background to-primary/10">
			{/* Hero Section */}
			<main className="container mx-auto flex flex-1 items-center px-6">
				<div className="flex w-full flex-col items-center text-center">
					{/* Logo Mark */}
					<div className="mb-8">
						<Logo className="h-32 w-32 drop-shadow-lg" />
					</div>

					{/* Title */}
					<h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
						Safe Rate Mortgage
					</h1>

					{/* Subtitle */}
					<p className="text-xl text-gray-600 dark:text-gray-400 mb-8 max-w-2xl">
						Manage your mortgage payments, statements, and account details all in one place.
					</p>


					{/* CTA Buttons */}
					<div className="flex flex-col sm:flex-row gap-4">
						<Button asChild size="lg">
							<a href="/auth/sign-in">Sign In</a>
						</Button>
						{isDevelopment && (
							<Button asChild size="lg" variant="outline">
								<a href="/test-login">Test Login (Dev Only)</a>
							</Button>
						)}
					</div>
				</div>
			</main>

			{/* Footer */}
			<footer className="mt-auto border-t border-gray-100 dark:border-gray-800 py-6">
				<div className="container mx-auto px-6 text-center text-sm text-gray-500 dark:text-gray-400">
					<p>&copy; {new Date().getFullYear()} Safe Rate. All rights reserved.</p>
				</div>
			</footer>
		</div>
	);
};

export default Index;
